import type { ClaudiStickerId } from '../../domain';
import type { CharacterId, GiantId } from '../../domain/ids/ids';
import type { NavBarTab } from '../screens/components/composite/nav/nav_bar/NavBar';

export type ScreenId =
  | 'loading'
  | 'welcome1'
  | 'welcome2'
  | 'map'
  | 'newDelivery'
  | 'selectCharacter'
  | 'level'
  | 'successDelivery'
  | 'failDelivery'
  | 'deliveryResult'
  | 'deliveryList'
  | 'stickers'
  | 'stickerReward'
  | 'tickets'
  | 'taskList'
  | 'taskDetail'
  | 'quiz'
  | 'dailyStrike'
  | 'rating'
  | 'playerLevel';

/** Business tasks that open a detail screen with a CTA (not quiz). */
export type TaskDetailKind = 'notifications' | 'daily_login' | 'vk_subscribe';

/** Overlay screens rendered on top of the stack (e.g. pause over level). */
export type OverlayScreenId = 'pause';

export type ScreenParams = {
  giantId?: GiantId;
  characterId?: CharacterId;
  levelKey?: number;
  orderIndex?: number;
  /** Show real delivery item (replay from «Мои доставки»). */
  revealItem?: boolean;
  /** Passes granted by the last successful daily-login claim (dailyStrike screen). */
  rewardPasses?: number;
  /** Which flight-ticket business task detail to show. */
  taskKind?: TaskDetailKind;
  /** New stickers unlocked by the last completed delivery (successDelivery). */
  unlockedStickers?: ClaudiStickerId[];
  /** Current sticker shown on stickerReward. */
  stickerId?: ClaudiStickerId;
  /** Remaining stickers to show after the current one. */
  remainingStickers?: ClaudiStickerId[];
  /** Opened from «Мои доставки» — hide replay and return to the list. */
  hideRestart?: boolean;
};

export type ScreenEntry = {
  id: ScreenId;
  params?: ScreenParams;
};

export type OverlayEntry = {
  id: OverlayScreenId;
};

export const HUB_TAB_TO_SCREEN: Record<NavBarTab, ScreenId> = {
  map: 'map',
  deliveries: 'deliveryList',
  rewards: 'stickers',
};

export const SCREEN_TO_HUB_TAB: Partial<Record<ScreenId, NavBarTab>> = {
  map: 'map',
  deliveryList: 'deliveries',
  stickers: 'rewards',
  tickets: 'map',
  rating: 'map',
  playerLevel: 'map',
  taskList: 'map',
  taskDetail: 'map',
};

/** TaskList indices that open side flows (see TaskListScreenModelScreen TASK_TEMPLATES). */
export const TASK_INDEX_NOTIFICATIONS = 0;
export const TASK_INDEX_DAILY_LOGIN = 1;
export const TASK_INDEX_QUIZ = 2;
export const TASK_INDEX_VK_SUBSCRIBE = 3;

/** Map list index → detail screen kind (quiz opens its own screen). */
export function taskKindFromIndex(taskIndex: number): TaskDetailKind | null {
  if (taskIndex === TASK_INDEX_NOTIFICATIONS) {
    return 'notifications';
  }
  if (taskIndex === TASK_INDEX_DAILY_LOGIN) {
    return 'daily_login';
  }
  if (taskIndex === TASK_INDEX_VK_SUBSCRIBE) {
    return 'vk_subscribe';
  }
  return null;
}
